<script setup>

const props = defineProps({
  ann:{
    type: Object,
    required: true
  }
})

import { VideoStore } from '@/front/stores/video_store.js';
const videoStore = VideoStore();
import { AnnStore } from '@/front/stores/ann_store.js';
const annStore = AnnStore();
const baseDesign = videoStore.video.design || {}
const customStyle = props.ann.customStyle && JSON.parse(props.ann.customStyle) || {}

const styling = computed(() => {

  let bgColor = props.ann.background_color || customStyle.comment_background_color || baseDesign.comment_background_color
  // Only set the background to dark if the text is white-ish
  if (
    bgColor == 'rgba(0, 0, 0, 0)'
    && ['#fff', '#ffffff', 'white', 'rgb(255, 255, 255)'].includes(
      (props.ann.text_color || customStyle.color || videoStore.video.design.comment_text_color || '').toLowerCase()
    )
  ) {
    bgColor = 'rgba(0, 0, 0, 0.8)'
  }
  return {
    'color': props.ann.text_color || customStyle.color || videoStore.video.design.comment_text_color, 
    'background': bgColor, 
    'borderRadius': (props.ann.border_radius || customStyle.borderRadius || baseDesign.comment_border_radius) + 'px',
  }
})
</script>

<template>
  <div class="text-center w-fit px-4 py-2 mx-auto select-none" :style="styling">

    <span v-if="!annStore.isEditing" v-safe-html="ann.content" ></span>
    <span v-else v-safe-html="ann.content" v-once></span>
  </div>
  <!-- {{  styling }} -->

</template>